(function () {
  // Consider "mobile" any viewport <= 1024 (covers phones + small tablets)
  const isMobile = () => window.matchMedia("(max-width: 1024px)").matches;

  // Blum has <main id="mainContent"> — scroll there (images are above options)
  function scrollToProductTop() {
    const main = document.getElementById("mainContent") || document.querySelector("main");
    if (!main) return;

    // Slight delay so variant image swap begins first
    setTimeout(() => {
      main.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  }

  // Detect clicks on variant buttons/swatches within the product form area
  function clickedVariantButton(target) {
    if (!target) return false;

    // Most Blum option buttons are buttons/labels inside the product info area
    const btn = target.closest("button, label");
    if (!btn) return false;

    // Only if it's inside a product page form/info area (avoid header/footer clicks)
    if (
      btn.closest('form[action*="/cart/add"]') ||
      btn.closest(".product__info") ||
      btn.closest(".product-info") ||
      btn.closest(".product-form") ||
      btn.closest('[data-section-type="main-product"]')
    ) {
      return true;
    }

    return false;
  }

  // Capture click (Blum button variants rely on click, not change)
  document.addEventListener(
    "click",
    function (e) {
      if (!isMobile()) return;
      if (!clickedVariantButton(e.target)) return;

      scrollToProductTop();
    },
    true
  );
})();